import React, { useEffect } from "react";
import s from "./Footer.module.css";

const Footer = () => {

    useEffect(() => {
        
    }, [] )

    return ( 
        <div className={s.footer}>
            
        </div>
     );
}
 
export default Footer;